// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpCaractsEspec extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_caracts_espec";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpCaractsEspec {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Característiques especials",
                "cz": "Speciální funkce",
                "da": "Særlige funktioner",
                "de": "Besondere Merkmale",
                "en": "Special features",
                "eu-ES": "Ezaugarri bereziak",
                "fi": "Lisäominaisuudet",
                "fr": "Fonctionnalités spéciales",
                "ga-ES": "Características especiais",
                "hi": "विशेष लक्षण",
                "hu": "Különleges jellemzők",
                "it": "Caratteristiche Speciali",
                "no": "Spesielle funksjoner",
                "nl": "Bijzondere kenmerken",
                "pl": "Specjalne cechy",
                "pt": "Características especiais",
                "ro": "Caracteristici speciale",
                "ru": "Особые характеристики",
                "sv": "Specialfunktioner",
                "sk": "Špeciálne vlastnosti"
            },
            "defecto": "Características especiales"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
